import React, { useRef, useEffect } from 'react';
import Chart from "chart.js/auto";
import { color, radius, fontFamily } from '../Theme';
/**
 * Bar chart with the brand chart defaults (bar colour, radius, grid and tick
 * colours come from the per-brand tokens, never hard-coded here).
 *
 * @param {*} data
 *  data = [{
 *  label: "label",
 *  value: 4
 * }] 
 * @returns 
 */
export function BarChart({ data, title, units }) {
    const canvas = useRef()

    useEffect(() => {
        const tick = color("chart-tick")
        const chart = new Chart(canvas.current, {
            type: 'bar',
            data: {
                labels: data?.map(d => d.label),
                datasets: [{
                    data: data?.map(d => d.value),
                    barThickness: 30,
                    backgroundColor: color("chart-bar"),
                    borderColor: color("chart-bar-border"),
                    borderWidth: 1,
                    borderRadius: radius("bar"),
                    borderSkipped: false,
                }]
            },
            options: {
                font: { family: fontFamily() },
                plugins: {
                    legend: {
                        display: false
                    },
                    title: {
                        display: title ? true : false,
                        text: title,
                        color: tick,
                    },
                    tooltip: {
                        callbacks: {
                            label: (tooltipItem) => {
                                if (units) return `${tooltipItem.formattedValue} ${units}`
                                return tooltipItem.formattedValue;
                            }
                        },
                    },
                },
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        grid: { display: false },
                        border: { color: color("chart-grid") },
                        ticks: { color: tick },
                    },
                    y: {
                        beginAtZero: true,
                        grid: { color: color("chart-grid") },
                        border: { display: false },
                        ticks: { color: tick, precision: 0 },
                    },
                },
            }
        });

        return () => chart.destroy()
    }, [data, title, units])

    return (
        <canvas ref={canvas} style={{ height: "100%", width: "100%" }}></canvas>
    )
}
